import { useError, useGetAiDiscoverabilityReports, useLoader } from "@piiqtechnologies/ui-lib";
import React, { createContext, useContext, useEffect, useMemo } from "react";
import { useAuthContext } from "./AuthContext";
const AiDiscoverabilityContext = createContext(undefined);
export const AiDiscoverabilityProvider = ({ children }) => {
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { user } = useAuthContext();
    const [fetchReports, reportsResponse, loadingReports, errorLoadingReports] = useGetAiDiscoverabilityReports();
    useEffect(() => {
        user && fetchReports();
    }, [user]);
    useEffect(() => {
        setLoader(loadingReports, "loadingReports");
        return () => setLoader(false, "loadingReports");
    }, [loadingReports]);
    useEffect(() => {
        if (errorLoadingReports) {
            setError(errorLoadingReports === null || errorLoadingReports === void 0 ? void 0 : errorLoadingReports.message);
        }
    }, [errorLoadingReports]);
    const value = useMemo(() => ({
        reportsData: reportsResponse || [],
        isLoading: loadingReports,
        error: errorLoadingReports,
        refetchReports: fetchReports,
    }), [reportsResponse, loadingReports, errorLoadingReports, fetchReports]);
    return React.createElement(AiDiscoverabilityContext.Provider, { value: value || null }, children);
};
export const useAiDiscoverabilityContext = () => {
    const context = useContext(AiDiscoverabilityContext);
    if (context === undefined) {
        throw new Error("useAiDiscoverabilityContext must be used within an AiDiscoverabilityProvider");
    }
    return context;
};
